
import { createContext, useContext, useEffect, useState } from "react";
import {auth} from "./firebase/firebaseConfig";
import api from "./services/api";


const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = auth.onIdTokenChanged(async (authUser) => {
            if (authUser) {
                try {
                    const idToken = await authUser.getIdToken();
                    api.defaults.headers.authorization = `Bearer ${idToken}`;
                    setUser(authUser);
                } catch (error) {
                    console.error("Error getting idToken:", error);
                    setUser(null);
                }
            } else {
                setUser(null);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const value = { user, setUser, loading };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};
